import {makeStyles} from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  textField: {
    display: 'block'
  },
  quickPreviewTextField: {
    display: 'block',
    padding: '0 8px',
    borderRadius: '4px',
    marginTop: '4px',
    marginBottom: '8px',
    border: '1px solid #D1D9E0',
    '& .MuiInputLabel-root': {
      padding: '4px 10px'
    },
    '& .Mui-error': {
      color: 'rgba(218, 9, 1, 1)'
    }
  },
  quickPreviewTextFieldError: {
    borderColor: 'rgba(218, 9, 1, 1)'
  },
  helperText: {
    color: theme.palette.secondary.main
  }
}))
